// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".config-view[data-v-6d93e716]{position:relative}.config-view .extra[data-v-6d93e716]{position:absolute;top:15px;right:30px}.map-warp[data-v-6d93e716]{width:100%;height:600px}", ""]);
// Exports
module.exports = exports;
